import { authFetch } from "~helpers/authFetch";
import type {
  IUpdateStream,
  TTimelineResponse,
  TTimelineUpdatePayload,
  TUpdateKeyframeIntervalPayload,
} from "./interfaces";

export async function getStreamContent(stream: string) {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/stream/${stream}`,
    { headers: { 'x-include-not-found-in-provider': 'true' } }
  )
    .then((streamResponse) => {
      return streamResponse.json();
    })
    .catch(() => {
      throw new Error("Problemas na requisição");
    });

  return response;
}

export async function getCategoryProductsPaginated(
  streamName: string,
  categoryId: number,
  page: number = 1,
  limit: number = 24,
  signal?: AbortSignal
) {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/stream/${streamName}/category/${categoryId}/products?page=${page}&limit=${limit}`,
    { signal }
  )
    .then((streamResponse) => {
      return streamResponse.json();
    })
    .catch((error) => {
      if (error.name === 'AbortError') {
        throw new Error('Request cancelled');
      }
      throw new Error("Problemas na requisição");
    });

  return response;
}

export async function getProductsCache(streamName: string) {
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/stream/${streamName}/products-cache`
  );

  if (response.status !== 200) {
    throw new Error("products cache not found");
  }

  return await response.json();
}

export async function saveStream(data: IUpdateStream, streamId: number) {
  return await authFetch({
    path: `${process.env.REACT_APP_BACKEND_URL}/stream/${streamId}`,
    method: "PUT",
    data: data,
  });
}

export async function getProductsTimeline(streamId: number): Promise<TTimelineResponse> {
  const timelineResult = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/stream/${streamId}/products/timeline`
  ).then((result) => (result.status === 200 ? result.json() : {}));

  return timelineResult as TTimelineResponse;
}

export async function updateProductsTimeline(
  streamId: number,
  data: TTimelineUpdatePayload
) {
  return await authFetch({
    path: `${process.env.REACT_APP_BACKEND_URL}/stream/${streamId}/products/timeline`,
    method: "PUT",
    data,
  });
}

export async function updateProductsTimelineKeyframeInterval(
  streamId: number,
  keyframeId: string,
  data: TUpdateKeyframeIntervalPayload
) {
  return await authFetch({
    path: `${process.env.REACT_APP_BACKEND_URL}/stream/${streamId}/products/timeline/keyframes/${keyframeId}`,
    method: "PATCH",
    data,
  });
}

export async function deleteProductsTimelineKeyframe(streamId: number, keyframeId: string) {
  return await authFetch({
    path: `${process.env.REACT_APP_BACKEND_URL}/stream/${streamId}/products/timeline/keyframes/${keyframeId}`,
    method: "DELETE",
  });
}

export async function updateHasMeasure(streamId: number, hasMeasure: boolean) {
  return await authFetch({
    path: `${process.env.REACT_APP_BACKEND_URL}/measure/${streamId}/has-measure`,
    method: "PATCH",
    data: { has_measure: hasMeasure ? 1 : 0 },
  });
}
